import { organizationRouteNames } from '../../../../routing/routeNames/organizerRouteNames'

const {
  organizationEvents,
  liveEvents,
  pastEvents,
  organizationAddEvent,
  organizationProfileInfo,
  organizationFinanceInfo,
  //organizationContractsAndTerms,
  organizationMailingList,
  organizationSubscribers,
  organizationMessages,
  organizationUsers,
  organizationLoyaltyCoupons,
  organizationLoyaltyCouponAdd,
  organizationPromoCodes,
  organizationPromoCodeInfo,
  organizationReports,
  organizationPayouts,
  ticketCategories,
  organizationBundleOffers,
  organizationTicketingDeals,
} = organizationRouteNames

/**
 * Sidebar keys for mapping routes to sidebar links
 * Some are string literals because for those links there isn't any route, they are just dropdowns for their subroutes
 *
 * They are in order as they are in Sidebar
 */
const sidebarKeys = {
  events: organizationEvents,
  liveEvents: liveEvents,
  pastEvents: pastEvents,
  organizationInfo: organizationProfileInfo,
  financeInfo: organizationFinanceInfo,
  // contractsAndTerms: organizationContractsAndTerms,
  mailingList: organizationMailingList,
  subscribers: organizationSubscribers,
  messages: organizationMessages,
  users: organizationUsers,
  coupons: organizationLoyaltyCoupons,
  promoCodes: organizationPromoCodes,
  reports: organizationReports,
  payouts: organizationPayouts,
  ticketCategories: ticketCategories,
  bundleOffers: organizationBundleOffers,
  ticketingDeals: organizationTicketingDeals,
}

/**
 * Sidebar links - objects for sidebar configuration
 *
 * Type:
 * {
 *    label: Name displayed in sidebar
 *    icon: Name of icon, representing the one inside assets/sidebar-icons
 *    key: Key for mapping the link to sidebar, take from sidebarKeys
 *    modulesRequired?: List of modules required for displaying this link
 *    allowedRoles?: List of roles for which this link will be displayed
 *    linkedRoutes: List of all routes for which this link will be highlighted as active and disabled for clicking (including its internal route)
 *    internalRoute: {
 *      name: Name of route this link will lead to, take from routeNames object
 *    }
 *    subroutes? List of route objects, only dropdowns have this property
 * }
 */
export const organizationSidebarConfiguration = [
  {
    label: 'Events',
    key: sidebarKeys.events,
    icon: 'events',
    subroutes: [
      {
        label: 'Live events',
        key: sidebarKeys.liveEvents,
        linkedRoutes: [liveEvents],
        internalRoute: {
          name: liveEvents,
        },
      },
      {
        label: 'Past events',
        key: sidebarKeys.pastEvents,
        linkedRoutes: [pastEvents],
        internalRoute: {
          name: pastEvents,
        },
      },
    ],
    linkedRoutes: [organizationEvents, organizationAddEvent, liveEvents, pastEvents],
    internalRoute: {
      name: liveEvents,
    },
  },
  {
    label: 'Organization info',
    key: sidebarKeys.organizationInfo,
    icon: 'account',
    allowedOrganizationRoles: ['OWNER', 'ADMIN'],
    linkedRoutes: [organizationProfileInfo],
    internalRoute: {
      name: organizationProfileInfo,
    },
  },
  {
    label: 'Finance info',
    key: sidebarKeys.financeInfo,
    allowedOrganizationRoles: ['OWNER'],
    linkedRoutes: [organizationFinanceInfo],
    icon: 'finance',
    internalRoute: {
      name: organizationFinanceInfo,
    },
  },
  // {
  //   label: 'Contracts and terms of use',
  //   key: sidebarKeys.contractsAndTerms,
  //   linkedRoutes: [organizationContractsAndTerms],
  //   icon: 'contracts-and-terms',
  //   internalRoute: {
  //     name: organizationContractsAndTerms,
  //   },
  // },
  {
    label: 'Payouts',
    key: sidebarKeys.payouts,
    allowedOrganizationRoles: ['OWNER', 'ADMIN'],
    linkedRoutes: [organizationPayouts],
    icon: 'reports',
    internalRoute: {
      name: organizationPayouts,
    },
  },
  {
    label: 'Ticket categories',
    key: sidebarKeys.ticketCategories,
    allowedOrganizationRoles: ['OWNER', 'ADMIN'],
    linkedRoutes: [ticketCategories],
    icon: 'ticket-types',
    internalRoute: {
      name: ticketCategories,
    },
  },
  {
    label: 'Mailing list',
    key: sidebarKeys.mailingList,
    icon: 'subscribers',
    allowedOrganizationRoles: ['OWNER', 'ADMIN'],
    linkedRoutes: [organizationSubscribers, organizationMailingList, organizationMessages],
    internalRoute: {
      name: organizationSubscribers,
    },
    subroutes: [
      {
        label: 'Subscribers list',
        key: sidebarKeys.subscribers,
        linkedRoutes: [organizationSubscribers],
        internalRoute: {
          name: organizationSubscribers,
        },
      },
      {
        label: 'Mobile app messages',
        key: sidebarKeys.messages,
        linkedRoutes: [organizationMessages],
        internalRoute: {
          name: organizationMessages,
        },
      },
    ],
  },
  {
    label: 'Users',
    key: sidebarKeys.users,
    icon: 'people',
    allowedOrganizationRoles: ['OWNER', 'ADMIN'],
    linkedRoutes: [organizationUsers],
    internalRoute: {
      name: organizationUsers,
    },
  },
  {
    label: 'Ticketing deals',
    key: sidebarKeys.ticketingDeals,
    icon: 'promo-codes',
    allowedOrganizationRoles: ['OWNER', 'ADMIN'],
    linkedRoutes: [organizationPromoCodes, organizationPromoCodeInfo, organizationBundleOffers],
    internalRoute: {
      name: organizationTicketingDeals,
    },
    subroutes: [
      {
        label: 'Promo codes',
        key: sidebarKeys.promoCodes,
        icon: 'promo-codes',
        linkedRoutes: [organizationPromoCodes, organizationPromoCodeInfo],
        internalRoute: {
          name: organizationPromoCodes,
        },
      },
      {
        label: 'Bundle offers',
        key: sidebarKeys.bundleOffers,
        icon: 'bundles',
        linkedRoutes: [organizationBundleOffers],
        internalRoute: {
          name: organizationBundleOffers,
        },
      },
    ],
  },
  {
    label: 'Reports',
    key: sidebarKeys.reports,
    icon: 'reports',
    allowedOrganizationRoles: ['OWNER', 'ADMIN'],
    linkedRoutes: [organizationReports],
    internalRoute: {
      name: organizationReports,
    },
  },
]
